import { render } from "./App.vue?vue&type=template&id=6432c89a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6432c89a&lang=css"

import exportComponent from "D:\\mnry7\\Documents\\front-saberes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__